import { useEffect, useMemo, useState } from "react";
import { AdminCompanyResponseDtoTypeEnum } from "shared/api";
import { FieldDescriptorsByCompany } from "../field-descriptors";
import { FieldDescriptor } from "../types";

export const useFieldDescriptorGet = (companyType: AdminCompanyResponseDtoTypeEnum | undefined) => {
  const [fieldDescriptors, setFieldDescriptors] = useState<FieldDescriptor[]>([]);

  useEffect(() => {
    if (companyType) {
      setFieldDescriptors(FieldDescriptorsByCompany[companyType]);
    }
  }, [companyType]);

  const requiredFields = useMemo(() => {
    if (fieldDescriptors) {
      return fieldDescriptors.map(fieldDescriptor => fieldDescriptor.name);
    }

    return [];
  }, [fieldDescriptors]);

  return {
    requiredFields,
    fieldDescriptors,
  } as const;
}